/* eslint-disable no-unused-vars */
import api from '@utils/api'

import { mergeEmailToFinalLayout } from '@utils/general'

import { SET_VALUES_EMAIL } from '@constants/actionType'
import { LANGUAGE_DEFAULT } from '@constants/general';


export const getAllEmails = () => async (dispatch, getState) => {
  const response = await api.getAllEmails()
  return response
}

export const setDetailEmail = ({id, nombre, descripcion, asunto, plantilla = "", comodines = "[]", activo}) => async (dispatch, getState) => {
  const { catalogs } = getState()
  const keysLenguages = catalogs.keysLanguageCatalog
  if (asunto) asunto = JSON.parse(asunto)
  if (comodines) comodines = JSON.parse(comodines)
  if (plantilla) plantilla = JSON.parse(plantilla)

  const general = keysLenguages.reduce((accum, language) => {
    const getAsunto = asunto[language] || ''
    // const getDescription = description[language] || ''
    const getPlantilla = plantilla && (plantilla[language] || plantilla[LANGUAGE_DEFAULT])
      ? decodeURIComponent(escape(window.atob(plantilla[language] || plantilla[LANGUAGE_DEFAULT])))
      : ''
    accum[language] = { asunto: getAsunto, plantilla: getPlantilla }
    return accum
  }, {})

  dispatch({
    type: SET_VALUES_EMAIL,
    payload: {
      general: {
        nombre,
        estatus: activo,
        descripcion,
        ...general,
      },
      comodines,
      id
    },
  });

}

export const getDetailEmail = ({id}) => async (dispatch, getState) => {
  const response = await api.getDetailEmail(id)

  if (!response?.status) dispatch(setDetailEmail(response.data))

  return response
}


export const addEmail = () => async (dispatch, getState) => {
  const { keysLanguageCatalog } = getState().catalogs
  const { general, comodines } = getState().email
  const data = {
    nombre: general.nombre,
    descripcion: general.descripcion,
    activo: general.estatus,
    asunto: {"es": ""},
    plantilla: {},
    comodines
  }
  await keysLanguageCatalog.map(item => {
    const formattingHtml = mergeEmailToFinalLayout(general[item].plantilla || general[LANGUAGE_DEFAULT].plantilla)
    const encodedEmail = window.btoa(unescape(encodeURIComponent(formattingHtml)))

    data.plantilla[item] = encodedEmail
    data.asunto[item] = general[item].asunto || general[LANGUAGE_DEFAULT].asunto
    // atob(encoded) // Decodificar base 64
    return true
  })

  data.asunto = JSON.stringify(data.asunto)
  data.plantilla = JSON.stringify(data.plantilla)
  data.comodines = JSON.stringify(data.comodines)

  const response = await api.addEmail(data)
  return response
}

export const updateEmail = () => async (dispatch, getState) => {
  const { keysLanguageCatalog } = getState().catalogs
  const { general, id, comodines } = getState().email
  const data = {
    id,
    nombre: general.nombre,
    descripcion: general.descripcion,
    activo: general.estatus,
    asunto: {"es": ""},
    plantilla: {},
    comodines
  }
  await keysLanguageCatalog.map(item => {
    const formattingHtml = mergeEmailToFinalLayout(general[item].plantilla)
    const encodedEmail = window.btoa(unescape(encodeURIComponent(formattingHtml)))

    data.plantilla[item] = encodedEmail
    data.asunto[item] = general[item].asunto || general[LANGUAGE_DEFAULT].asunto
    // atob(encoded) // Decodificar base 64
    return true
  })

  data.asunto = JSON.stringify(data.asunto)
  data.plantilla = JSON.stringify(data.plantilla)
  data.comodines = JSON.stringify(data.comodines)

  const response = await api.editEmail(data)
  return response

}